import 'jquery';
import 'jquery-ui-dist/jquery-ui.js';
import 'jquery-sticky/jquery.sticky.js';

import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap-notify/bootstrap-notify.js';

window['jQuery'] = $;

import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min.js';

import 'jstimezonedetect/dist/jstz.js';

import 'toc/lib/toc.js';

import 'moment/moment.js';
import * as webNotification from 'simple-web-notification';
window['webNotification'] = webNotification;

import 'autolinker/dist/Autolinker.js';